import { Injectable } from '@angular/core';

import { WeatherResponse } from '../../../shared/interfaces';
import { SignageConfigurationModel } from '../../config/models';
import { RuntimeSlideModel } from '../../slides/models';
import { FetchContextModel } from '../models';
import { ContentProvider } from '../interfaces';
import { ContentKind, SlideLayout, SlideTimingKind } from '../../slides/enums';
import { PresentationSlot } from '../enums';
import { RefreshTier } from '../../config/enums';

@Injectable()
export class WeatherContentProvider implements ContentProvider<WeatherResponse> {
  public readonly kind = ContentKind.Weather;
  public readonly tier = RefreshTier.Secondary;
  public readonly order = 80;
  public readonly presentation = PresentationSlot.Overlay;

  public isEnabled(config: SignageConfigurationModel): boolean {
    return config.enabled[this.kind] === true;
  }

  public async fetch(context: FetchContextModel): Promise<WeatherResponse[]> {
    const weather = await context.source.loadWeather(context.signal);

    return weather ? [weather] : [];
  }

  public toSlides(items: WeatherResponse[]): RuntimeSlideModel[] {
    return items.map((weather): RuntimeSlideModel => ({
      id: 'weather:0:overlay', kind: this.kind, layout: SlideLayout.Backdrop,
      content: { id: 0, providerChannelIds: [], weather },
      duration: { kind: SlideTimingKind.Fixed, milliseconds: 20000 }, meta: { sourceId: 0 }
    }));
  }
}
